<template>
  <div class="ntb-container">
    <div class="row">
      <div class="col-md-12">
        <carousel
          :autoplay="true"
          :autoplayTimeout="10000"
          :loop="true"
          :perPage="3"
          :paginationEnabled="false"
          :speed="5000"
        >
          <slide
            v-for="item in datas"
            :key="item.id"
            class="ntb-ticket"
            :class="{
              'ntb-bg-danger no-border': item.total > 0,
              'ntb-bg-success no-border': !item.total || item.total <= 10
            }"
          >
            <div class="row">
              <div class="col-md-1"></div>
              <div class="col-md-11">
                {{ item.name }} :
                <span v-if="item.total > 0">
                  Bekleyen
                  <strong>{{ item.total }}</strong> Talep
                </span>
                <span v-else>Bekleyen Talep Yok</span>
                <span :class="{ changed: item.isChange }"
                  >( {{ item.pingDate | DateFormat }} )</span
                >
              </div>
            </div>
          </slide>
        </carousel>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      site: this.$store.getters.getSite,
      auth: this.$store.getters.getModules,
      service: this.$store.getters.getHub,
      datas: []
    };
  },
  filters: {
    DateFormat(value) {
      if (!value) return "Giriş Yapılmamış";

      let date = value.split("T")[0].split("-");
      let time = value.split("T")[1].split(".")[0];
      return date[2] + "/" + date[1] + "/" + date[0] + " " + time;
    }
  },
  methods: {},

  computed: {
    getAppList() {
      return this.$store.getters.getAppListData;
    }
  },
  watch: {
    "$store.getters.getSite"() {
      this.site = this.$store.getters.getSite;
      this.$store.commit("clearBotList");
      this.$store.dispatch("getBotListService");
    },
    "$store.getters.getModules"() {
      this.auth = this.$store.getters.getModules;
    },
    "$store.getters.getBotList"() {
      const bots = this.$store.getters.getBotList;
      this.datas = bots.filter((item, idx) => item.isOpen).slice(0, 3);
    }
  },
  created() {},
  mounted() {},
  destroyed() {}
};
</script>

<style scoped>
.ntb-ticket {
  color: var(--bs-ntb-ticket-font-color);
  border-radius: 4px;
  padding: 6px 8px;
  margin: 10px 20px 0px 20px;
  text-align: center;
  width: 100%;
  max-height: 58px !important;
}

.ntb-container {
  position: fixed;
  width: calc(100% - 335px);
  top: 3.8rem;
  left: 0;
  margin: 0 0 0 335px;
  padding: 12px 0px 0px 0px;
  transition: margin-left 0.3s ease-in-out;
  border-radius: 4px;
  overflow: hidden;
  background-color: transparent;
  backdrop-filter: blur(5px); /* Adjust the blur intensity as needed */
  -webkit-backdrop-filter: blur(5px); /* For Safari */
  -moz-backdrop-filter: blur(5px); /* For Firefox */
  -o-backdrop-filter: blur(5px); /* For older versions of Opera */
  z-index: 1034;
  cursor: move;
}

.ntb-text-success {
  color: rgb(35, 92, 35);
}

.ntb-text-danger {
  color: rgb(190, 30, 30);
}

.ntb-bg-success {
  background-color: rgba(69, 180, 69, 0.68);
}

.ntb-bg-danger {
  background-color: rgba(190, 30, 30, 0.68);
}

.VueCarousel-slide {
  max-height: 40px;
}

.changed {
  font-weight: 700;
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/WatchCarousel.vue